import React from 'react';
import MedicalReportDetailGermanyForm, {
	MedicalReportDetailGermanyFormValues,
} from './MedicalReportDetailGermanyForm';

interface MedicalReportDetailGermanyValues
	extends Omit<MedicalReportDetailGermanyFormValues, 'diagnosis'> {
	diagnosis: string;
}

interface Props {
	onSuccess: (values: MedicalReportDetailGermanyValues) => void;
	defaultData?: any;
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	disableSubmit?: boolean;
	isMeddiCase: boolean;
}

const MedicalReportDetailGermany: React.FC<Props> = ({
	onSuccess,
	defaultData,
	disableSubmit,
	patientId,
	isMeddiCase,
}) => {
	const handleSubmit = (values: MedicalReportDetailGermanyFormValues) => {
		const modifiedValues: MedicalReportDetailGermanyValues = {
			...values,
			diagnosis: values?.diagnosis?.label,
		};
		onSuccess(modifiedValues);
	};

	return (
		<MedicalReportDetailGermanyForm
			onSubmit={handleSubmit}
			defaultData={defaultData}
			disableSubmit={disableSubmit}
			patientId={patientId}
			isMeddiCase={isMeddiCase}
		/>
	);
};

export default MedicalReportDetailGermany;
